const CONTACT_API_URL = import.meta.env.CONTACT_API_URL || '';
const TURNSTILE_SITE_KEY = import.meta.env.TURNSTILE_SITE_KEY || '';

let captchaToken = null;
let widgetId = null;
let turnstileReady = false;
let pendingSubmit = null;
let onTurnstileError = null;

function renderTurnstile(container) {
  if (container && window.turnstile && widgetId === null) {
    widgetId = window.turnstile.render(container, {
      sitekey: TURNSTILE_SITE_KEY,
      callback: function (token) {
        captchaToken = token;
        if (pendingSubmit) {
          var fn = pendingSubmit;
          pendingSubmit = null;
          fn(token);
        }
      },
      "error-callback": function (errorCode) {
        console.error("Turnstile error:", errorCode);
        captchaToken = null;
        if (pendingSubmit) {
          pendingSubmit = null;
          if (onTurnstileError) {
            onTurnstileError(errorCode);
          }
        }
        return true;
      },
      "expired-callback": function () {
        captchaToken = null;
      },
      theme: "dark",
      size: "invisible",
    });
    turnstileReady = true;
  }
}

function resetTurnstile() {
  if (widgetId !== null && window.turnstile) {
    window.turnstile.reset(widgetId);
  }
  captchaToken = null;
}

function executeTurnstile() {
  if (widgetId !== null && window.turnstile) {
    window.turnstile.execute(widgetId);
  }
}

function submitForm(form, emailInput, nameInput, messageInput, submitButton, buttonText, statusMessage, originalButtonText) {
  setFormDisabled(true, emailInput, nameInput, messageInput, submitButton);
  buttonText.textContent = "Sending...";

  fetch(CONTACT_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      source: "productionready",
      name: nameInput.value,
      email: emailInput.value,
      message: messageInput.value,
      _next: window.location.href,
      _error: window.location.href,
      cf_turnstile_response: captchaToken,
    }),
  })
    .then(function (response) {
      if (response.ok) {
        showStatus(statusMessage, "success", "Message sent successfully!");
        form.reset();
        resetTurnstile();
      } else {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            var errorMsg = "Failed to send message. Please try again.";
            if (data.message) {
              if (Array.isArray(data.message)) {
                errorMsg = data.message.join(", ");
              } else {
                errorMsg = data.message;
              }
            }
            showStatus(statusMessage, "error", errorMsg);
            resetTurnstile();
          });
      }
    })
    .catch(function () {
      showStatus(
        statusMessage,
        "error",
        "Network error. Please check your connection and try again.",
      );
      resetTurnstile();
    })
    .finally(function () {
      setFormDisabled(false, emailInput, nameInput, messageInput, submitButton);
      buttonText.textContent = originalButtonText;
    });
}

function setFormDisabled(disabled, emailInput, nameInput, messageInput, submitButton) {
  emailInput.disabled = disabled;
  nameInput.disabled = disabled;
  messageInput.disabled = disabled;
  submitButton.disabled = disabled;
  if (disabled) {
    submitButton.classList.add("disabled");
  } else {
    submitButton.classList.remove("disabled");
  }
}

function showStatus(el, type, message) {
  el.textContent = message;
  el.className = "contact-form-status";
  if (type) {
    el.classList.add("status-" + type);
  }
}

function clearStatus(el) {
  el.textContent = "";
  el.className = "contact-form-status";
}

document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector(".contact-form");
  if (!form) return;

  if (!CONTACT_API_URL || !TURNSTILE_SITE_KEY) {
    return;
  }

  var emailInput = form.querySelector("#contact-email");
  var nameInput = form.querySelector("#contact-name");
  var messageInput = form.querySelector("#contact-message");
  var submitButton = form.querySelector(".contact-submit-button");
  var buttonText = submitButton.querySelector(".primary-button-text");
  var statusMessage = form.querySelector(".contact-form-status");
  var turnstileContainer = document.querySelector(".turnstile-container");

  var originalButtonText = buttonText.textContent;

  window.onTurnstileLoad = function () {
    renderTurnstile(turnstileContainer);
  };

  var isDev = window.location.hostname.includes('.replit.dev') ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  if (isDev) {
    turnstileReady = true;
    captchaToken = 'dev-bypass';
  } else {
    var existingScript = document.querySelector('script[src*="turnstile"]');
    if (!existingScript) {
      var script = document.createElement("script");
      script.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad";
      script.async = true;
      script.onerror = function () {
        showStatus(
          statusMessage,
          "error",
          "Verification service unavailable. Please try again later.",
        );
      };
      document.head.appendChild(script);
    } else if (window.turnstile) {
      renderTurnstile(turnstileContainer);
    }
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    clearStatus(statusMessage);

    if (!turnstileReady) {
      showStatus(
        statusMessage,
        "error",
        "Verification is loading. Please try again in a moment.",
      );
      return;
    }

    if (captchaToken) {
      submitForm(form, emailInput, nameInput, messageInput, submitButton, buttonText, statusMessage, originalButtonText);
    } else {
      setFormDisabled(true, emailInput, nameInput, messageInput, submitButton);
      buttonText.textContent = "Verifying...";
      pendingSubmit = function () {
        submitForm(form, emailInput, nameInput, messageInput, submitButton, buttonText, statusMessage, originalButtonText);
      };
      onTurnstileError = function (errorCode) {
        showStatus(
          statusMessage,
          "error",
          "Verification failed (" + (errorCode || "unknown") + "). Please try again.",
        );
        setFormDisabled(false, emailInput, nameInput, messageInput, submitButton);
        buttonText.textContent = originalButtonText;
        resetTurnstile();
      };
      executeTurnstile();
      setTimeout(function () {
        if (pendingSubmit) {
          pendingSubmit = null;
          onTurnstileError = null;
          showStatus(
            statusMessage,
            "error",
            "Verification timed out. Please try again.",
          );
          setFormDisabled(false, emailInput, nameInput, messageInput, submitButton);
          buttonText.textContent = originalButtonText;
          resetTurnstile();
        }
      }, 10000);
    }
  });
});
